import { render, staticRenderFns } from "./bank_card_dialog.vue?vue&type=template&id=522fc2ea"
import script from "./bank_card_dialog.vue?vue&type=script&lang=js"
export * from "./bank_card_dialog.vue?vue&type=script&lang=js"
import style0 from "./bank_card_dialog.vue?vue&type=style&index=0&id=522fc2ea&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports